import React from 'react';
import { matchRoutes, useLocation } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../store';
import { cloneDeep } from 'lodash-es';

import {
  updatePageContent,
  updatePageLayoutContent,
  updateComponentDataDefaults,
  updateComponentDefaults,
} from '../../store/slices/templatesConfig';

const AdminCustomization = () => {
  const setPages = useAppSelector((state) => state.templatesConfig.setPages);
  const reroute = useAppSelector((state) => state.templatesConfig.reroute);
  const location = useLocation();

  const dispatch = useAppDispatch();

  const matches = React.useMemo(() => {
    const paths: any = Object.keys(setPages).map((path) => ({ ...setPages[path], path }));
    if (reroute) {
      try {
        const extraRouting: any = JSON.parse(reroute);
        Object.keys(extraRouting).forEach((k: any) => {
          const pageDef = extraRouting[k];

          if (typeof pageDef === 'string' && setPages[pageDef]) {
            // If it's a string, treat it as a destination URL
            paths.push({ ...setPages[pageDef], path: k });
          } else if (pageDef?.dest && pageDef?.route === false && setPages[pageDef.dest]) {
            paths.push({ path: k, ...setPages[pageDef.dest] });
          } else if (pageDef?.dest) {
            const matches = matchRoutes(paths, { pathname: pageDef?.dest });
            if (matches && matches.length > 0) {
              const cln: any = { ...matches[0] };
              delete cln.route;
              paths.push({ ...cln, path: k });
            }
          }
        });
      } catch (e) {
        console.error('Error parsing reroute JSON:', e);
      }
    }

    //console.log('React.useMemo[matches]', { paths, location });
    return matchRoutes(paths, location);
  }, [setPages, location, reroute]);

  const handleIframeMessage = (event: MessageEvent) => {
    if (
      event.origin &&
      (event.origin.endsWith('.play-online.com') ||
        event.origin.startsWith('http://localhost') ||
        event.origin.startsWith('http://127.0.0.1'))
    ) {
      if (event.data.type === 'upc') {
        dispatch(updatePageContent({ id: event.data.payload.id, content: event.data.payload.content }));
      }
      if (event.data.type === 'uplc') {
        dispatch(updatePageLayoutContent({ id: event.data.payload.id, content: event.data.payload.content }));
      }
      if (event.data.type === 'ucdd') {
        dispatch(updateComponentDataDefaults({ content: event.data.payload.content }));
      }
      if (event.data.type === 'ucd') {
        dispatch(updateComponentDefaults({ content: event.data.payload.content }));
      }
      if (event.data.type === 'sl') {
        // selected component / component data
        if (event.data.payload.id) {
          const element = document.querySelector(`[data-cjs-n-id="${event.data.payload.id}"]`);
          element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
      if (event.data.type === 'mouse-over') {
        if (event.data.payload.parentId && event.data.payload.targetId) {
          const element = document.querySelector(
            `[data-cjs-n-id="${event.data.payload.parentId}"] [data-cjs-n-id="${event.data.payload.targetId}"]`,
          );
          element?.classList.add('cjs-n-hover');
        } else if (event.data.payload.parentId) {
          const element = document.querySelector(`[data-cjs-n-id="${event.data.payload.parentId}"]`);
          element?.classList.add('cjs-n-hover');
        }
      }
      if (event.data.type === 'mouse-out') {
        if (event.data.payload.parentId && event.data.payload.targetId) {
          const element = document.querySelector(
            `[data-cjs-n-id="${event.data.payload.parentId}"] [data-cjs-n-id="${event.data.payload.targetId}"]`,
          );
          element?.classList.remove('cjs-n-hover');
        } else if (event.data.payload.parentId) {
          const element = document.querySelector(`[data-cjs-n-id="${event.data.payload.parentId}"]`);
          element?.classList.remove('cjs-n-hover');
        }
      }
    }
  };

  React.useEffect(() => {
    window.onmessage = handleIframeMessage;
    return () => {
      window.onmessage = null;
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    if (matches?.length) {
      if (window !== window.parent) {
        const match = cloneDeep(matches[0]);
        // @ts-ignore
        match.url = window.location.href;
        window.top?.postMessage({ type: 'pageChange', payload: match }, '*');
      }
    }
  }, [matches, location, reroute]);

  return null;
};

export default AdminCustomization;
